import React, { useEffect, useState } from "react";
import { Button, Col, Container, Dropdown, Form, Image, Row } from "react-bootstrap";
//-------- HEADER COMPONENT IMPORT ---------//
import WithoutImageHeader from "../../../Helper/withoutImageHeader";
//------------ CONSTANTS IMPORT ------------//
import { faAngleDown, faAngleUp, faPlus, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import * as Constants from "../../../Helper/constants/constants";
import TagsInput from "react-tagsinput";

const AssignMedicine = () => {
    const breadcrumData = ['Dashboard', 'Patient Detail'];
    const breadcrumItem = ['Assign Medicine'];
    const [tags, setTags] = useState([]);
    return (
        <div className="assign_medicine_section">
            <WithoutImageHeader
                header={Constants.ASSIGN_MEDICINE}
                breadcrumData={breadcrumData}
                breadcrumItem={breadcrumItem}
                lefticon={'menu'}
            />
            <div className="assign_medicine_area">
                <Container>
                    <Row>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                            <div className="medicine_main_area">
                                <div className="form">
                                    <Form>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                            <Form.Group className="form-group">
                                                <Form.Label>Brand Name<span>*</span></Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder={'Enter brand name'}
                                                />
                                            </Form.Group>
                                            <Form.Group className="form-group">
                                                <Form.Label>Medicine Name<span>*</span></Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder={'Enter Medicine'}
                                                />
                                            </Form.Group>
                                            <Form.Group className="form-group">
                                                <Form.Label>Salt<span>*</span></Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder={'Enter text here'}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Row>
                                            <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                                <Form.Group className="form-group">
                                                    <Form.Label>Dosage<span>*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={'Enter Dosage here'}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                                <Form.Group className="form-group">
                                                    <Form.Label>Route</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={'Enter route here'}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <div className="tag_area">
                                            <h6>Frequency<span>*</span></h6>
                                            <TagsInput
                                                value={tags}
                                                inputValue={tags}
                                            />
                                        </div>
                                    </Form>
                                </div>
                                <div className="form_area">
                                    <div className="icon_cross">
                                        <a href="javascript:;"><FontAwesomeIcon icon={faXmark} /></a>
                                    </div>
                                    <Form>
                                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                            <Form.Group className="form-group">
                                                <Form.Label>Brand Name<span>*</span></Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder={'Enter brand name'}
                                                />
                                            </Form.Group>
                                            <Form.Group className="form-group">
                                                <Form.Label>Medicine Name<span>*</span></Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder={'Enter Medicine'}
                                                />
                                            </Form.Group>
                                            <Form.Group className="form-group">
                                                <Form.Label>Salt<span>*</span></Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder={'Enter text here'}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Row>
                                            <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                                <Form.Group className="form-group">
                                                    <Form.Label>Dosage<span>*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={'Enter Dosage here'}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                                <Form.Group className="form-group">
                                                    <Form.Label>Route</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={'Enter route here'}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <div className="tag_area">
                                            <h6>Frequency<span>*</span></h6>
                                            <TagsInput
                                                value={tags}
                                                inputValue={tags}
                                            />
                                        </div>
                                    </Form>
                                </div>
                                <div className="more_btn_area">
                                    <a href="javascript:;" className="btn btn-primary"><FontAwesomeIcon icon={faPlus} className="plus_icon" />Add More</a>
                                </div>
                                <div className="btn_area">
                                    <Button
                                        className="cancelBtn"
                                        type="button"
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        className="submitBtn"
                                        type="submit"
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};

export default AssignMedicine;
